var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidefaceemoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 348,
    viewBox: "0 0 348 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.541 268.413C315.725 215.812 311.98 147.094 268.407 94.7547C224.846 42.429 157.945 26.2889 94.7549 78.8952C31.5782 131.49 35.3226 200.208 78.8897 252.541C122.457 304.873 189.351 321.019 252.541 268.413Z",
    fill: "url(#paint0_radial_1080_20)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.541 268.413C315.725 215.812 311.98 147.094 268.407 94.7547C224.846 42.429 157.945 26.2889 94.7549 78.8952C31.5782 131.49 35.3226 200.208 78.8897 252.541C122.457 304.873 189.351 321.019 252.541 268.413Z",
    fill: "url(#paint1_radial_1080_20)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.541 268.413C315.725 215.812 311.98 147.094 268.407 94.7547C224.846 42.429 157.945 26.2889 94.7549 78.8952C31.5782 131.49 35.3226 200.208 78.8897 252.541C122.457 304.873 189.351 321.019 252.541 268.413Z",
    fill: "url(#paint2_radial_1080_20)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M252.541 268.413C315.725 215.812 311.98 147.094 268.407 94.7547C224.846 42.429 157.945 26.2889 94.7549 78.8952C31.5782 131.49 35.3226 200.208 78.8897 252.541C122.457 304.873 189.351 321.019 252.541 268.413Z",
    fill: "url(#paint3_radial_1080_20)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M252.541 268.413C315.725 215.812 311.98 147.094 268.407 94.7547C224.846 42.429 157.945 26.2889 94.7549 78.8952C31.5782 131.49 35.3226 200.208 78.8897 252.541C122.457 304.873 189.351 321.019 252.541 268.413Z",
    fill: "url(#paint4_radial_1080_20)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.541 268.413C315.725 215.812 311.98 147.094 268.407 94.7547C224.846 42.429 157.945 26.2889 94.7549 78.8952C31.5782 131.49 35.3226 200.208 78.8897 252.541C122.457 304.873 189.351 321.019 252.541 268.413Z",
    fill: "url(#paint5_radial_1080_20)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M252.541 268.413C315.725 215.812 311.98 147.094 268.407 94.7547C224.846 42.429 157.945 26.2889 94.7549 78.8952C31.5782 131.49 35.3226 200.208 78.8897 252.541C122.457 304.873 189.351 321.019 252.541 268.413Z",
    fill: "url(#paint6_radial_1080_20)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M252.541 268.413C315.725 215.812 311.98 147.094 268.407 94.7547C224.846 42.429 157.945 26.2889 94.7549 78.8952C31.5782 131.49 35.3226 200.208 78.8897 252.541C122.457 304.873 189.351 321.019 252.541 268.413Z",
    fill: "url(#paint7_radial_1080_20)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.098 247.478C172.568 232.934 174.94 206.982 160.396 189.512C145.852 172.042 119.899 169.67 102.429 184.214C84.9593 198.758 82.5872 224.71 97.1312 242.18C111.675 259.65 137.628 262.022 155.098 247.478Z",
    fill: "url(#paint8_radial_1080_20)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M224.855 190.484C240.721 177.275 242.875 153.705 229.667 137.839C216.458 121.973 192.888 119.819 177.022 133.027C161.155 146.236 159.001 169.806 172.21 185.672C185.419 201.538 208.989 203.693 224.855 190.484Z",
    fill: "url(#paint9_radial_1080_20)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.06 226.922C157.884 223.837 161.056 220.022 163.391 215.7C165.727 211.378 167.18 206.634 167.664 201.745C168.149 196.856 167.657 191.919 166.216 187.222C164.775 182.525 162.414 178.162 159.27 174.386C156.127 170.61 152.264 167.497 147.906 165.229C143.548 162.96 138.783 161.581 133.887 161.171C128.991 160.762 124.062 161.33 119.388 162.844C114.714 164.357 110.388 166.785 106.661 169.986C99.2826 176.324 94.6927 185.309 93.8821 195.001C93.0715 204.693 96.1052 214.316 102.328 221.791C108.551 229.266 117.464 233.994 127.143 234.954C136.822 235.914 146.49 233.029 154.06 226.922ZM229.957 164.62C233.73 161.479 236.847 157.625 239.131 153.279C241.415 148.933 242.82 144.18 243.267 139.291C243.714 134.402 243.194 129.472 241.735 124.784C240.277 120.097 237.91 115.742 234.769 111.969C231.628 108.195 227.774 105.078 223.428 102.794C219.082 100.51 214.329 99.1048 209.44 98.658C204.551 98.2111 199.622 98.7316 194.934 100.19C190.246 101.648 185.891 104.015 182.118 107.156C174.497 113.501 169.708 122.613 168.806 132.488C167.903 142.363 170.96 152.192 177.305 159.814C183.649 167.435 192.762 172.223 202.637 173.126C212.512 174.028 222.336 170.964 229.957 164.62Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.072 209.508C146.457 205.024 149.842 198.584 150.479 191.605C151.117 184.626 148.957 177.68 144.473 172.294C139.989 166.908 133.549 163.524 126.571 162.886C119.592 162.248 112.645 164.409 107.259 168.893C101.873 173.376 98.4893 179.816 97.8514 186.795C97.2135 193.774 99.3741 200.72 103.858 206.106C108.342 211.492 114.781 214.876 121.76 215.514C128.739 216.152 135.686 213.991 141.072 209.508Z",
    fill: "url(#paint10_linear_1080_20)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M215.832 147.269C221.218 142.786 224.602 136.346 225.24 129.367C225.878 122.388 223.717 115.442 219.233 110.056C214.75 104.67 208.31 101.286 201.331 100.648C194.352 100.01 187.406 102.171 182.02 106.654C176.634 111.138 173.25 117.578 172.612 124.557C171.974 131.536 174.135 138.482 178.618 143.868C183.102 149.254 189.542 152.638 196.521 153.276C203.5 153.914 210.446 151.753 215.832 147.269Z",
    fill: "url(#paint11_linear_1080_20)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3621 189.958C74.9808 181.312 72.2866 160.634 88.5326 147.109",
    stroke: "url(#paint12_linear_1080_20)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M206.976 82.8856C199.087 77.993 179.24 71.5947 162.994 85.1196",
    stroke: "url(#paint13_linear_1080_20)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M192.804 237.943C192.804 237.943 193.938 225.538 207.476 214.267C221.014 202.996 233.419 204.13 233.419 204.13",
    stroke: "url(#paint14_linear_1080_20)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1080_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.522 72.7282) rotate(93.0614) scale(330.326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1080_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.519 72.7429) rotate(92.1004) scale(343.057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1080_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(153.934 149.962) rotate(61.5324) scale(157.191 201.332)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1080_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.931 148.843) rotate(95.2224) scale(361.232)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1080_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.303 180.427) rotate(37.9144) scale(247.915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1080_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.866 174.219) rotate(15.9354) scale(117.264 84.9992)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1080_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(215.396 161.831) rotate(-29.9118) scale(102.811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1080_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.184 158.432) rotate(4.19338) scale(520.133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1080_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.886 170.759) rotate(95.2224) scale(80.203 41.5104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1080_20",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.677 120.809) rotate(95.2224) scale(67.5538 38.1352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1080_20",
    x1: 138.854,
    y1: 131.129,
    x2: 171.533,
    y2: 184.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1080_20",
    x1: 145.923,
    y1: 125.244,
    x2: 178.602,
    y2: 178.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1080_20",
    x1: 85.6881,
    y1: 194.174,
    x2: 75.5444,
    y2: 181.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#524049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2C42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1080_20",
    x1: 209.794,
    y1: 90.8544,
    x2: 199.65,
    y2: 78.6699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#524049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2C42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1080_20",
    x1: 196.205,
    y1: 200.729,
    x2: 207.476,
    y2: 214.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F3C43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512756"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidefaceemoji);
export default __webpack_public_path__ + "static/media/Side face emoji.87fc088b7e111bf67c4430fbafffb5b1.svg";
export { ForwardRef as ReactComponent };